import { environment } from "../../environments/environment";

export const Constant = {
    messageStatus: {
        success: "success",
        info: "info",
        warn: "warn",
        error: "warn",
    },
    response: {
        isSuccess: "isSuccess",
        message: "message",
        data: "data",
        exception: "exception",
    },
    notification: {
        showBulkyAgain: 'showBulkyAgain',
    },
    auths: {
        isLoginIn: 'crm-loggedIn',
        token: 'crm-token',
        userId: 'crm-userId',
        userName: 'crm-userName',
        currentUser: 'crm-currentUser',
        fullName: 'crm-fullName',
        tokenFirebase: 'crm-tokenFirebase',
        datetimeLogin: 'crm-datetimeLogin',
    },
    classes: {
        includes: {
            province: {
                country: "Country",
            },
            district: {
                province: "Province",
            },
            ward: {
                district: "District",
            },
            hub: {
                district: "District",
                ward: "Ward",
                centerHub: "CenterHub",
                poHub: "PoHub",
            },
            user: {
                department: "Department",
                role: "Role",
                hub: "Hub",
            },
            shipment: {
                cusDepartment: "CusDepartment",
                sender: "Sender",
                service: "Service",
                fromHub: "FromHub",
                toHub: "ToHub",
                fromHubRouting: "FromHubRouting",
                toHubRouting: "ToHubRouting",
                fromWard: "FromWard",
                fromDistrict: "FromWard.District",
                fromProvince: "FromWard.District.Province",
                toWard: "ToWard",
                toDistrict: "ToWard.District",
                toProvince: "ToProvince",
                shipmentStatus: "ShipmentStatus",
                package: "Package",
                pickUser: "PickUser",
                deliverUser: "DeliverUser",
                transferUser: "TransferUser",
                returnUser: "ReturnUser",
                transferReturnUser: "TransferReturnUser",
                receiveHub: "ReceiveHub",
                currentHub: "CurrentHub",
                currentEmp: "CurrentEmp",
                paymentType: "PaymentType",
                serviceDVGT: "ServiceDVGT",
                weight: "Weight",
                totalBox: "TotalBox",
                structure: "Structure",
                companyFrom: "CompanyFrom",
                companyTo: "CompanyTo",
                shipmentServiceDVGTs: "ShipmentServiceDVGTs",
                serviceDVGTIds: "ServiceDVGTIds",
                boxes: "Boxes",
                tpl: "TPL",
                listGoods: "ListGoods",
                requestShipment: "RequestShipment",
                paymentCODType: "PaymentTypeCOD",
                businessUser: "BusinessUser",
                receiver: "Receiver",
                parrentShipment: "ParrentShipment"
            },
            customer: {
                province: "Province",
                district: "District",
                ward: "Ward",
                paymentType: "PaymentType",
            },
            serviceDVGTPrice: {
                formula: "Formula",
                serviceDVGT: "ServiceDVGT",
                priceListDVGT: "PriceListDVGT",
                calculateBy: "CalculateBy"
            },
            priceServiceDetail: {
                priceService: "PriceService",
                area: "Area",
                weight: "Weight",
            },
            priceService: {
                priceList: "PriceList",
                service: "Service",
                areaGroup: "AreaGroup",
                weightGroup: "WeightGroup",
            },
            priceList: {
                hub: "Hub",
                priceListDVGT: "PriceListDVGT"
            },
            packagePriceList: {
                packType: "PackType",
                formula: "Formula",
            },
            weight: {
                formula: "Formula",
                weightGroup: "WeightGroup",
                structure: "Structure",
            },
            areaGroup: {
                hub: "Hub",
            },
            area: {
                areaGroup: "AreaGroup",
                province: "Province",
                district: "District",
            },
            listGoods: {
                createdByHub: "CreatedByHub",
                listGoodsTypeId: "ListGoodsTypeId",
                listGoodsType: "ListGoodsType",
                numPrint: "NumPrint",
                createdHub: "CreatedHub",
                createdWhen: "CreatedWhen",
                tpl: "TPL",
                listGoodsStatus: "ListGoodsStatus",
                fromHub: "FromHub",
                toHub: "ToHub",
                transportType: "TransportType",
                emp: "Emp",
            },
            listReceiptMoney: {
                fromHub: "FromHub",
                toHub: "ToHub",
                paidByEmp: "PaidByEmp",
                userCreated: "UserCreated",
                userModified: "UserModified",
                listReceiptMoneyStatus: "ListReceiptMoneyStatus",
                listReceiptMoneyType: "ListReceiptMoneyType"
            },
            listCustomerPayment: {
                hubCreated: "HubCreated",
                customer: "Customer",
                userCreated: "UserCreated",
                userModified: "UserModified",
                listCustomerPaymentType: "ListCustomerPaymentType"
            },
            transportType: {
                tplTransportTypes: "TPLTransportTypes.TPL",
            },
            provinceCode: {
                customer: "Customer",
                hub: "Hub",
                user: "User",
                provideCodeStatus: "ProvideCodeStatus"
            },
            truckSchedule: {
                fromHub: "FromHub",
                toHub: "ToHub",
                truckScheduleStatus: "TruckScheduleStatus",
                truck: "Truck"
            },
            truckScheduleDetail: {
                hub: "Hub",
                truckScheduleStatus: "TruckScheduleStatus"
            },
            uploadExcelHistory: {
                user: "User"
            }
        },
    },
    pages: {
        login: {
            name: 'Đăng nhập',
            alias: 'dang-nhap',
            hidden: true,
        },
        verifyLogin: {
            name: 'Duyệt đăng nhập',
            alias: 'duyet-dang-nhap'
        },
        page404: {
            name: 'Không tìm thấy trang',
            alias: '404',
        },
        page403: {
            name: 'Không có quyền truy cập',
            alias: '403',
        },
        changePassWord: {
            name: 'Thay đổi mật khẩu',
            alias: 'thay-doi-mat-khau',
            loadChildren: './change-password/change-password.module#ChangePasswordModule',
            children: {
                changePassWord: {
                    name: 'Đổi mật khẩu',
                    alias: '',
                }
            }
        },
        gpsLocation: {
            name: 'Định vị GPS',
            alias: 'dinh-vi-gps',
            loadChildren: './gps-location/gps-location.module#GpsLocationModule',
            children: {
                gpsLocation: {
                    name: 'Định vị GPS',
                    alias: '',
                }
            }
        },
        sendQrCode: {
            name: 'Hiển thị QrCode',
            alias: 'hien-thi-qr-code',
            hidden: true,
        },
        checkShipment: {
            name: 'Kiểm tra hàng hóa',
            alias: 'kiem-tra-hang-hoa',
            loadChildren: './check-shipment/check-shipment.module#CheckShipmentModule',
            children: {
                checkShipment: {
                    name: 'Kiểm tra hàng hóa',
                    alias: '',
                }
            }
        },
        shipment: {
            name: 'Quản lý vận đơn',
            alias: 'quan-ly-van-don',
            loadChildren: './shipment-management/shipment-management.module#ShipmentManagementModule',
            children: {
                createShipment: {
                    name: 'Tạo phiếu nhận hàng',
                    alias: 'tao-phieu-nhan-hang',
                },
                createShipmentContract: {
                    name: 'Tạo vận đơn hợp đồng',
                    alias: 'tao-van-don-hop-dong',
                },
                listShipment: {
                    name: 'Tìm kiếm hàng',
                    alias: 'danh-sach-van-don',
                },
                entryShipmentDetail: {
                    name: 'Nhập chi tiết',
                    alias: 'nhap-chi-tiet',
                },
                shipmentReceiveList: {
                    name: 'Danh sách hàng nhận',
                    alias: 'danh-sach-hang-nhan',
                },
                editSenderInfomation: {
                    name: 'Sửa thông tin phiếu gửi',
                    alias: 'sua-thong-tin-phieu-gui',
                },
                createInvoiceInfomation: {
                    name: 'Nhập thông tin xuất hóa đơn',
                    alias: 'nhap-thong-tin-xuat-hoa-don',
                },
                barcodePrintInfomation: {
                    name: 'Tìm kiếm thông tin in mã vạch',
                    alias: 'tim-kiem-thong-tin-in-ma-vach',
                }
            }
        },
        warehouse: {
            name: 'Quản lý kho',
            alias: 'quan-ly-kho',
            loadChildren: './warehouse-management/warehouse-management.module#WarehouseManagementModule',
            children: {
                inventory: {
                    name: 'Hàng tồn kho',
                    alias: 'hang-ton-kho',
                }
            }
        },
        unload: {
            name: 'Quản lý xuống hàng',
            alias: 'quan-ly-xuong-hang',
            loadChildren: './unload-management/unload-management.module#UnloadManagementModule',
            children: {
                unloadShipmentTranfer: {
                    name: 'Tạo phiếu xuống hàng trung chuyển',
                    alias: 'tao-phieu-xuong-hang-trung-chuyen',
                },
                handoverShift: {
                    name: 'Bàn giao ca',
                    alias: 'ban-giao-ca',
                },
                listHandoverShift: {
                    name: 'Danh sách bàn giao ca',
                    alias: 'danh-sach-ban-giao-ca'
                },
                listWarehousing: {
                    name: 'Hàng lưu kho',
                    alias: 'hang-luu-kho'
                },
                saveWarehouse: {
                    name: 'Xếp hàng vào kho',
                    alias: 'luu-kho',
                },
                listUnloadTranfer: {
                    name: ' Danh sách phiếu xuống hàng trung chuyển',
                    alias: 'danh-sach-phieu-xuong-hang-trung-chuyen',
                },
                unloadShipment: {
                    name: 'Tạo phiếu xuống hàng',
                    alias: 'tao-phieu-xuong-hang',
                },
                listUnload: {
                    name: ' Danh sách phiếu xuống hàng',
                    alias: 'danh-sach-phieu-xuong-hang',
                },
                printStockCode: {
                    name: 'In mã lưu kho',
                    alias: 'in-ma-luu-kho'
                },
            }
        },
        delivery: {
            name: 'Quản lý giao hàng',
            alias: 'quan-ly-giao-hang',
            loadChildren: './delivery-management/delivery-management.module#DeliveryManagementModule',
            children: {
                deliverys: {
                    name: 'Giao hàng',
                    alias: 'giao-hang',
                },
                deliveryCustomer: {
                    name: 'Giao hàng cho khách',
                    alias: 'giao-hang-cho-khach',
                },
                listOfVotesDelivered: {
                    name: 'Danh sách phiếu đã giao',
                    alias: 'danh-sach-phieu-da-giao'
                },
            }
        },
        transfer: {
            name: 'Chuyển hàng',
            alias: 'chuyen-hang',
            loadChildren: './transfer-management/transfer-management.module#TransferManagementModule',
            children: {
                wareHousingNew: {
                    name: 'Nhập kho hàng mới',
                    alias: 'nhap-kho-hang-moi'
                },
                createShippingOrders: {
                    name: 'Tạo phiếu chuyển hàng',
                    alias: 'tao-phieu-chuyen-hang',
                },
                shippingList: {
                    name: 'Danh sách chuyển hàng',
                    alias: 'danh-sach-chuyen-hang',
                },
                createTransferIssue: {
                    name: 'Tạo phiếu trung chuyển',
                    alias: 'tao-phieu-trung-chuyen'
                },
                
                listTransferIssue: {
                    name: 'Danh sách phiếu trung chuyển',
                    alias: 'danh-sach-phieu-trung-chuyen'
                },
                untransferIssue: {
                    name: 'Danh sách hàng chưa chuyển',
                    alias: 'danh-sach-hang-chua-chuyen'
                },
                listOfVotesDelivered: {
                    name: 'Danh sách phiếu đã giao',
                    alias: 'danh-sach-phieu-da-giao'
                },
                transportManagement: {
                    name: 'Quản lý chuyến xe',
                    alias: 'quan-ly-chuyen-xe'
                }
            }
        },

        general: {
            name: 'Quản lý chung',
            alias: 'quan-ly-chung',
            loadChildren: './general-management/general-management.module#GeneralManagementModule',
            children: {
                service: {
                    name: 'Dịch vụ',
                    alias: 'dich-vu',
                },
                paymentType: {
                    name: 'Hình thức thanh toán',
                    alias: 'hinh-thuc-thanh-toan',
                },
                contractType: {
                    name: 'Loại-hợp-đồng',
                    alias: 'loai-hop-dong',
                },
                structure: {
                    name: 'Nhóm hàng hóa',
                    alias: 'loai-hang-hoa',
                },
                packType: {
                    name: 'Loại gói',
                    alias: 'loai-goi',
                },
                serviceDVGT: {
                    name: 'Dịch vụ gia tăng',
                    alias: 'dich-vu-gia-tang',
                },
                reason: {
                    name: 'Lý do',
                    alias: 'ly-do',
                },
                reasonComplain: {
                    name: 'Lý do khiếu nại',
                    alias: 'ly-do-khieu-nai',
                },
                size: {
                    name: 'Kích thước',
                    alias: 'kich-thuoc',
                },
                transportType: {
                    name: 'Đi qua đối tác',
                    alias: 'di-qua-doi-tac',
                },
                PrintBillManagement: {
                    name: 'Quản lý mẫu in bill',
                    alias: 'quan-ly-mau-in-bill',
                },
                Holiday: {
                    name: 'Quản lý ngày lễ',
                    alias: 'quan-ly-ngay-le',
                },
                AccountingAccount: {
                    name: 'Tài khoản kế toán',
                    alias: 'tai-khoan-ke-toan',
                },
                AccountBank: {
                    name: 'Tài khoản ngân hàng',
                    alias: 'tai-khoan-ngan-hang',
                },
                Legal: {
                    name: 'Quản lý pháp nhân',
                    alias: 'quan-ly-phap-nhan',
                }
            }
        },
        price: {
            name: 'Quản lý giá cước',
            alias: 'quan-ly-gia-cuoc',
            loadChildren: './price-management/price-management.module#PriceManagementModule',
            children: {
                areaGroup: {
                    name: 'Nhóm khu vực',
                    alias: 'nhom-khu-vuc',
                },
                area: {
                    name: 'Khu vực tính giá',
                    alias: 'khu-vuc-tinh-gia',
                },
                weightGroup: {
                    name: 'Nhóm mức cân',
                    alias: 'nhom-muc-can',
                },
                weight: {
                    name: 'Mức cân',
                    alias: 'muc-can',
                },
                formula: {
                    name: 'Công thức',
                    alias: 'cong-thuc',
                },
                priceList: {
                    name: 'Bảng giá',
                    alias: 'bang-gia',
                },
                priceService: {
                    name: 'Bảng giá dịch vụ',
                    alias: 'bang-gia-dich-vu',
                },
                priceServiceDetail: {
                    name: 'Bảng giá DV chi tiết',
                    alias: 'bang-gia-dich-vu-chi-tiet',
                },
                priceServiceDetailBeta: {
                    name: 'Quản lý bảng giá Beta',
                    alias: 'quan-ly-bang-gia-beta',
                },
                priceServiceDetailExcel: {
                    name: 'Nhập giá bằng Excel',
                    alias: 'nhap-gia-excel',
                },
                serviceDVGTPrice: {
                    name: 'Bảng giá Dịch Vụ Gia Tăng',
                    alias: 'bang-gia-dvgt',
                },
                serviceDVGTPriceDetail: {
                    name: 'Bảng giá Dịch Vụ Gia Tăng Chi Tiết',
                    alias: 'bang-gia-dvgt-chi-tiet',
                },
                packagePrice: {
                    name: 'Bảng giá đóng gói',
                    alias: 'bang-gia-dong-goi',
                },
                chargedCOD: {
                    name: 'Khu vực tính phí COD',
                    alias: 'khu-vuc-tinh-phi-cod',
                },
                chargedRemote: {
                    name: 'Khu vực tính phí VSVX',
                    alias: 'khu-vuc-tinh-phi-vsvx',
                },
                checkPrice: {
                    name: 'Uớc tính giá',
                    alias: 'uoc-tinh-gia',
                },
                setupPriceToCus: {
                    name: 'Áp giá khách hàng',
                    alias: 'ap-gia-khach-hang',
                }
            }
        },
        report: {
            name: 'Báo cáo',
            alias: 'bao-cao',
            loadChildren: './report/report-management.module#ReportManagementModule',
            children: {
                reportDeliveryEmoloyee: {
                    name: 'Báo cáo thu tiền tài xế giao nhận',
                    alias: 'bao-cao-nv-giao-nhan',
                },
                reportSumary: {
                    name: 'Báo cáo tổng hợp',
                    alias: 'bao-cao-tong-hop',
                },
                reportPickupDeliver: {
                    name: 'Báo cáo nhận hàng',
                    alias: 'bao-cao-nhan-hang',
                },
                cancelShipment: {
                    name: 'Báo cáo hủy vận đơn',
                    alias: 'bao-cao-huy-van-don',
                },
               
                reportDiscountCustomer: {
                    name: 'Báo cáo quản lý giảm giá khách hàng',
                    alias: 'bao-cao-quan-ly-giam-gia-khach-hang',
                },
                
                reportPaymentPickupUser: {
                    name: 'Báo cáo thu tiền',
                    alias: 'bao-cao-thu-tien',
                },
                
                reportIncidents: {
                    name: 'Báo cáo sự cố',
                    alias: 'bao-cao-su-co',
                },
                reportDeliveryImage: {
                    name: 'Báo cáo xem ảnh giao hàng',
                    alias: 'bao-cao-xem-anh-phat-hang',
                },
                reportMonthlyRevenue: {
                    name: 'Báo cáo doanh thu tháng',
                    alias: 'bao-cao-doanh-thu-thang',
                },
                
                reportExportWarehouseRequest: {
                    name: 'Báo cáo hàng tồn kho',
                    alias: 'bao-cao-hang-ton-kho',
                },
                
                reportUpdateShipment: {
                    name: 'Báo cáo chỉnh sửa phiếu gửi',
                    alias: 'bao-cao-chinh-sua-phieu-gui'
                },
                reportPromotionShipment: {
                    name: 'Báo cáo mã giảm giá khách hàng',
                    alias: 'bao-cao-ma-giam-gia-khach-hang'
                },
                reportReceiverMoneyDelivery: {
                    name: 'Báo cáo thu tiền nhân viên',
                    alias: 'bao-cao-thu-tien-nhan-vien-giao-nhan'
                },
                reportShipping: {
                    name: 'Báo cáo chuyển hàng',
                    alias: 'bao-cao-chuyen-hang'
                },
                reportOutWarehouse: {
                    name: 'Báo cáo giao tận nơi ',
                    alias: 'bao-cao-giao-tan-noi'
                },
                reportUnload: {
                    name: 'Báo cáo xuống hàng ',
                    alias: 'bao-cao-xuong-hang'
                },
                reportShipmentContact: {
                    name: 'Báo cáo liên hệ LTN ',
                    alias: 'bao-cao-lien-he-ltn'
                },
                reportUnloadIsExist: {
                    name: 'Báo cáo xuống hàng dư',
                    alias: 'bao-cao-xuong-hang-du'
                },
                reportUnloadGoodsMissing: {
                    name: 'Báo cáo xuống hàng thiếu',
                    alias: 'bao-cao-xuong-hang-thieu'
                },
                
                reportDeliveryInfo: {
                    name: 'Báo cáo giao hàng',
                    alias: 'bao-cao-giao-hang'
                },
                reportTransactionHistory: {
                    name: 'Báo cáo thanh toán điện tử',
                    alias: 'bao-cao-thanh-toan-dien-tu'
                },
                reportShipmentToPartner: {
                    name: 'Báo cáo hàng đi đối tác',
                    alias: 'bao-cao-hang-di-doi-tac'
                },
                reportZalo: {
                    name: 'Báo cáo zalo',
                    alias: 'bao-cao-zalo'
                },
            }
        },
        receiptMoney: {
            name: 'Quản lý thu tiền',
            alias: 'quan-ly-thu-tien',
            loadChildren: './receive-money-management/receive-money-management.module#ReceiveMoneyManagementModule',
            children: {
                comfirmTransfer: {
                    name: 'Quản lý chuyển khoản',
                    alias: 'xac-nhan-chuyen-khoan',
                },
                comfirmMoneyFromHubOther: {
                    name: 'Xác nhận tiền từ các trung tâm',
                    alias: 'xac-nhan-tien-tu-trung-tam-khac',
                },
                comfirmMoneyFromHub: {
                    name: 'Kế toán xác nhận tiền từ ' + environment.poHubSortName + '/' + environment.stationHubSortName + '',
                    alias: 'xac-nhan-tien-tu-ttcnt',
                },
                comfirmMoneyFromEmp: {
                    name: 'Xác nhận nhận tiền',
                    alias: 'xac-nhan-nhan-tien',
                },
                comfirmMoneyFromAccountant: {
                    name: 'Thủ quỹ xác nhận tiền',
                    alias: 'thu-quy-xac-nhan-tien',
                },
                receiveMoneyFromHubOther: {
                    name: 'Nộp tiền về các trung tâm khác',
                    alias: 'nop-tien-ve-trung-tam-khac',
                },
                receiveMoneyFromAccountant: {
                    name: 'Nộp tiền về thủ quỹ',
                    alias: 'nop-tien-ve-thu-quy',
                },
                receiveMoneyFromHub: {
                    name: 'Nộp tiền về ' + environment.centerHubSortName + '/' + environment.poHubSortName + '/' + environment.stationHubSortName + '',
                    alias: 'nop-tien-ve-ttcnt',
                },
                receiveMoneyFromRider: {
                    name: 'Xác nhận tiền từ nhân viên',
                    alias: 'xac-nhan-tien-tu-nhan-vien',
                },
                accountantConfirmMoney: {
                    name: 'Kế toán xác nhận thu tiền',
                    alias: 'ke-toan-xac-nhan-thu-tien',
                },
                receiveMoneyFromCustomer: {
                    name: 'Thu tiền KH',
                    alias: 'thu-tien-kh',
                },
            }
        },
        invoiceManagement: {
            name: 'Quản lý hóa đơn',
            alias: 'quan-ly-hoa-don',
            loadChildren: './invoice-management/invoice-management.module#InvoiceManagementModule',
            children: {
                invoiceInfomation: {
                    name: 'Danh sách hàng yêu cầu XHĐ',
                    alias: 'danh-sach-hang-yeu-cau-xhd',
                },
                createInvoice: {
                    name: 'Tạo hóa đơn',
                    alias: 'tao-hoa-don'
                },
                listInvoice: {
                    name: 'Danh sách hóa đơn',
                    alias: 'danh-sach-hoa-don'
                },
            }
        },
        incidentManagement: {
            name: 'Quản lý sự cố',
            alias: 'quan-ly-su-co',
            loadChildren: '.incident-management/incident-management.module#IncidentManagementModule',
            children: {
                listIncident: {
                    name: 'Danh sách sự cố',
                    alias: 'danh-sach-su-co'
                }
            }
        },
        customerPayment: {
            name: 'Quản lý công nợ',
            alias: 'quan-ly-cong-no',
            loadChildren: './customer-payment-management/customer-payment-management.module#CustomerPaymentManagementModule',
            children: {
                customerPaymentDebt: {
                    name: 'Thanh toán nợ dài',
                    alias: 'thanh-toan-no-dai'
                },
                customerPaymentShortDebit: {
                    name: 'Thanh toán nợ ngắn',
                    alias: 'thanh-toan-no-ngan'
                },
                customerPaymentShipmentContract: {
                    name: 'Thanh toán cước phí VĐ HĐ',
                    alias: 'thanh-toan-cuoc-phi-vd-hd'
                }
            }
        },

        dashBoard: {
            name: 'Tổng quan',
            alias: 'dashboard',
            loadChildren: './welcome/welcome.module#WelcomeModule',
            children: {
                dashBoard: {
                    name: 'Tổng quan',
                    alias: '',
                },
            }
        },

        pickupManagement: {
            name: 'Quản lý lấy tận nơi',
            alias: 'quan-ly-lay-tan-noi',
            loadChildren: './new-pickup-management/new-pickup-management.module#NewPickupManagementModule',
            children: {
                listRequest: {
                    name: 'Quản lý lấy tận nơi',
                    alias: 'quan-ly-yeu-cau',
                },
                createShipmentContractRequest: {
                    name: 'Tạo vận đơn hợp đồng',
                    alias: 'tao-van-don-hop-dong',
                },

                printCodeTakePlace: {
                    name: 'In mã lấy tận nơi',
                    alias: 'in-ma-lay-tan-noi',
                },
                createContactRequestNew: {
                    name: 'Tạo phiếu liên hệ lấy tận nơi',
                    alias: 'tao-phieu-lien-he-lay-tan-noi'
                },
                listShipemntContact: {
                    name: 'Danh sách phiếu liên hệ LTN',
                    alias: 'danh-sach-lien-he-phieu-LTN'
                }
            }
        },

        newDeliveryPlace: {
            name: "Giao tận nơi",
            alias: "giao-tan-noi",
            loadChildren: "./new-delivery-place/new-delivery-place.module#NewDeliveryPlaceModule",
            children: {
                createNewDeliveryPlace: {
                    name: " Tạo phiếu giao tận nơi",
                    alias: "tao-phieu-giao-tan-noi",
                },
                ListNewDeliveryPlace: {
                    name: "DS phiếu giao tận nơi",
                    alias: "ds-phieu-giao-tan-noi",
                },
                warehouseDeliveryFailed: {
                    name: "Nhập kho hàng giao KTC",
                    alias: "nhap-kho-hang-giao-ktc",
                },
                listDeliveryFailed: {
                    name: 'Danh sách phiếu nhập kho KTC',
                    alias: 'danh-sach-phieu-nhap-kho-ktc'
                }
            }
        },
        historyPrint: {
            name: "Lịch sử In",
            alias: "lich-su-in",
            loadChildren: "./history-print/history-print.module#HistoryPrintModule",
            children: {
                printShipments: {
                    name: "DS In VĐ",
                    alias: "ds-in-vd",
                },
                followList: {
                    name: "DS In BK",
                    alias: "ds-in-bk",
                },
            }
        },

        promotionManagement: {
            name: 'Quản lý giảm giá',
            alias: 'quan-ly-giam-gia',
            loadChildren: './promotion-management/promotion-management.module#PromotionManagementModule',
            children: {
                promotionFormula: {
                    name: 'Công thức giảm giá',
                    alias: 'cong-thuc-giam-gia'
                },
                createPromotionFormula: {
                    name: 'Quản lý mã giảm giá',
                    alias: 'quan-ly-ma-giam-gia'
                },
                setupPromotionToCustomer: {
                    name: 'Áp mã giảm giá khách hàng',
                    alias: 'ap-ma-giam-gia-khach-hang'
                }
            }
        },
        shipmentPartnerManagement: {
            name: 'Quản lý vận đơn đối tác',
            alias: 'quan-ly-van-don-doi-tac',
            loadChildren: './shipment-partner-management.module#ShipmentPartnerManagementModule',
            children: {
                deliveryShipmentToPartner: {
                    name: 'Tạo đơn hàng đối tác',
                    alias: 'tao-don-hang-doi-tac'
                },
                listShipmentToPartner: {
                    name: 'Danh sách đơn hàng đối tác',
                    alias: 'danh-sach-don-hang-doi-tac'
                }
            }
        },
        parkOverNight: {
            name: "Gửi xe qua đêm",
            alias: "gui-xe-qua-dem",
            loadChildren: './park-over-night/park-over-night.module#ParkOverNightModule',
            children: {
                listParkingOverNight: {
                    name: "Danh sách vé xe",
                    alias: "danh-sach-ve-xe",
                },
                listVehicleType: {
                    name: "Danh sách loại xe",
                    alias: "danh-sach-loai-xe",
                },
                parkingPrice: {
                    name: "Bảng giá gửi xe",
                    alias: "bang-gia-gui-xe",
                },
                confirmPayment: {
                    name: "Xác nhận thu tiền",
                    alias: "xac-nhan-thu-tien",
                },
                listInvoiceCustomer: {
                    name: "Danh sách yêu cầu XHD",
                    alias: "danh-sach-yeu-cau-xhd",
                },
            }
        },
        luggageManagement: {
            name: 'Quản lý bao hành lý',
            alias: 'quan-ly-bao-hanh-ly',
            loadChildren: './luggage-managerment/luggage-managerment.module#LuggageManagermentModule',
            children: {
                packingLuggage: {
                    name: 'Đóng gói bao hành lý',
                    alias: 'dong-goi-bao-hanh-ly',
                },
                listLuggage: {
                    name: 'Danh sách bao hành lý',
                    alias: 'danh-sach-bao-hanh-ly',
                }
            },
        },
    }
}